import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BurgerMenu from '../../commons/BurgerMenu';
import { ReactComponent as IconInvoices } from '../../images/icn_fatture.svg';
import Header from '../../commons/Header';
import variables from '../../variables';
import { Col, CustomInput, FormGroup, Label, Row } from 'reactstrap';
import {
  ContFilterYear,
  ContPaginationPage,
  H4Styled,
} from '../../styled-components';
import generateYearOptions from '../../lib/helpers/generateYearOptions';
import SearchInput from '../../commons/SearchInput';
import Footer from '../../commons/Footer';
import Table from './Table';
import ModalInvoiceDetailPanoramica from '../../commons/ModalInvoiceDetailPanoramica';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import SailInvoice from './SailInvoice';

function SailInvoicesPresentational({
  data = [],
  total,
  query = {},
  onFilter,
  onCollectInvoice,
  onStatusChanged,
  subjects = [],
  onSendInvoice,
}) {
  const [t] = useTranslation('SAIL_INVOICE_PANORAMICA');
  const [modalState, setModalState] = useState({
    isOpen: false,
    selectedId: null,
  });

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:SAIL_INVOICES_PANORAMICA')}
            icon={
              <IconInvoices fill={variables.white} style={{ height: '30px' }} />
            }
          />
        </section>

        <section>
          <SailInvoice subjects={subjects} onSendInvoice={onSendInvoice} />
        </section>

        <section>
          <Row>
            <Col sm="12">
              <H4Styled>{t('TITLE')}</H4Styled>
            </Col>
          </Row>

          <Row>
            <Col sm="12" md="6" lg="6">
              <ContFilterYear className="no-width">
                <Row>
                  <Col xs="6">
                    <Label>DESTINATARIO</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectYear"
                        name="customer"
                        value={query.customer}
                        onChange={({ target: { value: customer } }) =>
                          onFilter({ customer })
                        }
                      >
                        <option value="">Tutti</option>
                        {subjects.map((subject) => (
                          <option value={subject._id} key={subject._id}>
                            {subject.businessName}
                          </option>
                        ))}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>
            <Col sm="12" md="6" lg="3">
              <ContFilterYear className="no-width">
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:YEAR')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectYear"
                        name="year"
                        value={query.year}
                        onChange={({ target: { value: year } }) =>
                          onFilter({ year })
                        }
                      >
                        {generateYearOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>
            <Col sm="12" md="6" lg="3">
              <ContFilterYear className="no-width">
                <Row>
                  <Col xs="6">
                    <Label>Pagato</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectPaid"
                        name="paid"
                        value={query.paid}
                        onChange={({ target: { value: paid } }) =>
                          onFilter({ paid })
                        }
                      >
                        <option value="">Tutti</option>
                        <option value="true">Pagato</option>
                        <option value="false">Non pagato</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>
            <Col sm="12" md="6" lg="3">
              <div className="mb-20">
                <SearchInput
                  query={query}
                  onFilter={onFilter}
                  label={t('NUMBER')}
                />
              </div>
            </Col>
          </Row>
        </section>

        <section>
          <Table
            data={data}
            total={total}
            query={query}
            onFilter={onFilter}
            onCollectInvoice={onCollectInvoice}
            setModalState={setModalState}
          />

          <ModalInvoiceDetailPanoramica
            modalState={modalState}
            setModalState={setModalState}
            onStatusChanged={onStatusChanged}
          />

          <ContPaginationPage>
            <p className="m-tb-20">{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={query.limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>

        <Footer />
      </div>
    </div>
  );
}

export default SailInvoicesPresentational;
